import { AppUrl } from "./app-url";
import { environment } from "../environments/environment";

export class AppConfig {
  app_host: string = "";
  assine_host: string = "";
  minha_loga_host: string = "";
  host_ms_fatura = "";

  private url = new AppUrl();

  constructor() {
    this.app_host = this.url.host;
    this.assine_host = this.url.host_assine;
    this.minha_loga_host = this.url.host_minha_loga;
    this.host_ms_fatura = this.url.host_ms_fatura;

    if (environment.production) {
      // TODO(feature/AutoRenegPart2): temporario p/ testar contra o homolog padrao - reverter pra https://admapp.netsulinternet.com.br antes de mergear em master
      this.app_host = "https://admapp.netsulinternet.com.br";
      this.assine_host = "https://assine.netsulinternet.com.br";
      this.minha_loga_host = "https://minhanetsul.netsulinternet.com.br/#";
      this.host_ms_fatura = "https://sgt.loga.net.br/z25f6ab772";
    }
  }
}



// WEBPACK FOOTER //
// /var/www/minha-netsul/src/app/app-config.ts